import { render } from "./VacancyList.vue?vue&type=template&id=58c8700e&scoped=true"
import script from "./VacancyList.vue?vue&type=script&lang=js"
export * from "./VacancyList.vue?vue&type=script&lang=js"

import "./public-job-vacancy.scss?vue&type=style&index=0&id=58c8700e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c8700e"]])

export default __exports__